import { Container, GridItem } from '@chakra-ui/react'
import React from 'react'

import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'

import ExploreCourseFilter from '@/components/Explore/ExploreCourseFilter'
import ExploreHeader from '@/components/Explore/ExploreHeader/ExploreHeader'
import ExploreTutors from '@/components/Explore/ExploreTutors'
import Layout from '@/components/Layout/Layout'
import ShwGrid from '@/components/Layout/ShwGrid'

const Tutors: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false)

  return (
    <Layout title="Explore | Tutors">
      <ExploreHeader type="tutor" />
      <Container>
        <ShwGrid>
          <GridItem colSpan={[12, 3]}>
            <ExploreCourseFilter disabled={isLoading} setPageDisabled={setIsLoading} />
          </GridItem>
          <GridItem colSpan={[12, 9]}>
            <ExploreTutors disabled={isLoading} setPageDisabled={setIsLoading} />
          </GridItem>
        </ShwGrid>
      </Container>
    </Layout>
  )
}

const TutorsPage = makePage(Tutors, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(TutorsPage)
export default TutorsPage
